import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import CountryService from "services/CountryService";

export const getCountry = createAsyncThunk(
    "country/listCountry",
    async (params, { rejectWithValue }) => {
        try {
            const response = await CountryService.listCountry(params);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Failed to add user"
            );
        }
    }
);
export const downloadCountryExcel = createAsyncThunk(
    "country/downloadCountryExcel",
    async ({ data, params }, { rejectWithValue }) => {
        try {
            const response = await CountryService.downloadCountryExcel(data, params);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Failed to add user"
            );
        }
    }
);
export const dropdownlistCountry = createAsyncThunk(
    "country/dropdownlistCountry",
    async (params, { rejectWithValue }) => {
        try {
            const response = await CountryService.listCountry(params);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Failed to add user"
            );
        }
    }
);
export const getSingleCountry = createAsyncThunk(
    "country/singleCountry",
    async (params, { rejectWithValue }) => {
        try {
            const response = await CountryService.singleCountry(params);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Failed to add user"
            );
        }
    }
);
export const addCountry = createAsyncThunk(
    "country/addCountry",
    async ({ data, params }, { rejectWithValue }) => {
        try {
            const response = await CountryService.addCountry(data, params);
            return response;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Failed to add user"
            );
        }
    }
);
export const updateCountry = createAsyncThunk(
    "country/updateCountry",
    async ({ data, params }, { rejectWithValue }) => {
        try {
            const response = await CountryService.updateCountry(data, params);
            return response;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Failed to add user"
            );
        }
    }
);
export const bulkCountryStatusUpdate = createAsyncThunk(
    "country/bulkCountryStatusUpdate",
    async ({ data, status }, { rejectWithValue }) => {
        try {
            const response = await CountryService.bulkStatusUpdate(data, status);
            return response;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Failed to add user"
            );
        }
    }
);

const initialState = {
    response: null,
    countries: {},
    dropdowncountryList: {},
    searchTerm: '',
    countryDetails: {},
    loading: false,
    excelLoading: false,
    dropDownloading: false,
    selectedCountry: null,
    isCountryDropdownOpen: false,
    message: null,
    error: null
}

const countrySlice = createSlice({
    name: "country",
    initialState,
    reducers: {
        setSelectedCountry: (state, action) => {
            state.selectedCountry = action.payload;
        },
        toggleCountryDropdown: (state) => {
            state.isCountryDropdownOpen = !state.isCountryDropdownOpen;
        },
        setCountryDropdownVisibility: (state, action) => {
            state.isCountryDropdownOpen = action.payload;
        },
        setCountryDropdownSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCountry.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCountry.fulfilled, (state, action) => {
                state.loading = false;
                state.countries = action.payload;
            })
            .addCase(getCountry.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(downloadCountryExcel.pending, (state) => {
                state.excelLoading = true;
                state.error = null;
            })
            .addCase(downloadCountryExcel.fulfilled, (state, action) => {
                state.excelLoading = false;
            })
            .addCase(downloadCountryExcel.rejected, (state, action) => {
                state.excelLoading = false;
                state.error = action.payload;
            })
            .addCase(dropdownlistCountry.pending, (state) => {
                state.dropDownloading = true;
                state.error = null;
            })
            .addCase(dropdownlistCountry.fulfilled, (state, action) => {
                state.dropDownloading = false;
                state.dropdowncountryList = action.payload;
            })
            .addCase(dropdownlistCountry.rejected, (state, action) => {
                state.dropDownloading = false;
                state.error = action.payload;
            })
            .addCase(getSingleCountry.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSingleCountry.fulfilled, (state, action) => {
                state.loading = false;
                state.countryDetails = action.payload;
            })
            .addCase(getSingleCountry.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(addCountry.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addCountry.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(addCountry.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateCountry.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCountry.fulfilled, (state, action) => {
                state.loading = false;

                const updatedCountry = action.payload?.data;
                // const countryId = updatedCountry?.id;

                // if (countryId && state.dropdowncountryList?.items?.length) {
                //     state.dropdowncountryList = {
                //         ...state.dropdowncountryList,
                //         items: state.dropdowncountryList.items.map(country =>
                //             country?.id === countryId ? { ...country, ...updatedCountry } : country
                //         )
                //     };
                //     state.selectedCountry = 'sample';
                //     // console.log("countryEdit", state.dropdowncountryList?.items);
                // }

            })

            .addCase(updateCountry.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(bulkCountryStatusUpdate.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(bulkCountryStatusUpdate.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(bulkCountryStatusUpdate.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export const { setSelectedCountry,
    setCountryDropdownVisibility,
    toggleCountryDropdown,
    setCountryDropdownSearchTerm
} = countrySlice.actions;
export default countrySlice.reducer;
